import {BlackjackBet} from "../BlackjackBet";
import {BlackjackActionName} from "./BlackjackActionName";

export class BlackjackAction {

    private actionName: BlackjackActionName;
    public bets: Array<BlackjackBet>;
    private insureHand: boolean;

    public constructor(blackjackActionName: BlackjackActionName, insureHand: boolean = false) {
        this.actionName = blackjackActionName;
        if (blackjackActionName === BlackjackActionName.INSURE) {
            this.insureHand = insureHand;
        }
    }

    public getActionName(): BlackjackActionName {
        return this.actionName;
    }

    public setBets(bets: Array<BlackjackBet>): void {
        if (this.actionName !== BlackjackActionName.DEAL) {
            throw new Error("Only deal action may have bets parameter setup!");
        }
        this.bets = bets;
    }

    public getBetAmount(): number {
        let betAmount = 0;
        for (let i = 0; i < this.bets.length; i++) {
            betAmount += this.bets[i].getBetAmount();
        }
        return betAmount;
    }

    public getInsureDecision(): boolean {
        return this.insureHand;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/BlackjackAction.ts